import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-decorations-deactivated',
    templateUrl: './toast-decorations-deactivated.component.pug',
    styleUrls: ['./toast-decorations-deactivated.component.less'],
})
export class ToastDecorationsDeactivatedComponent {
    @Input() count: number = null;

    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }
}
